/**
 * Created by khanhduong on 5/16/17.
 */

export default {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
};
